import React, { useState } from 'react';
import ModalBase from '../ModalBase';
import InputField from '../../InputField';
import PasswordField from '../../PasswordField';
import CryptoAmountInput from '../../CryptoAmountInput';
import higherLogo from '../../../assets/imgs/ico-higher-titulo.svg';
import { switchCripto } from '../../../utils/switchCripto';

function CryptoWithdrawal({ show, onClose, balanceData }) {
  const [coin, setCoin] = useState('USDT');
  const [network, setNetwork] = useState('');
  const [address, setAddress] = useState('');
  const [value, setValue] = useState('');
  const [password, setPassword] = useState('');

  const handleWithdraw = () => {
    const withdrawalData = {
      coin,
      network,
      address,
      value,
      password,
    };

    onClose(withdrawalData);
  };

  const getBalance = (symbol, balanceData) => {
    if(switchCripto() === "1"){
      for(let i=0; i<balanceData.length; i++){
        if(balanceData[i].currency_symbol === symbol){
          return balanceData[i].balance;
        }
      }
    } 
    else {
      for(let i=0; i<balanceData.length; i++){
        if(balanceData[i].asset === symbol.toUpperCase()){
          return balanceData[i].balance;
        }
      }
    }
  }

  const handleBack = () => {
    onClose(null);
  };    

  return (
    <ModalBase show={show} onClose={() => onClose(null)}>
      <div style={styles.container}>
        <div style={styles.closeButtonContainer}>
          <button style={styles.closeButton} onClick={handleBack}>
            &times;
          </button>
        </div>
        
        <div style={styles.leftPanel}>
          <h2 style={styles.title}>
            <img src={higherLogo} alt="Logo Higher" style={styles.logo} />
            Withdrawal
          </h2>
          
          <InputField readOnly={true} label="Coin" value={coin} onChange={e => setCoin(e.target.value)} />
          <label>
            <span style={{fontSize: "11px", color: "#888"}}>Network</span><br/>
            <select value={network} onChange={e => setNetwork(e.target.value)}>
              <option value="trc20">TRC20</option>
              <option value="erc20">ERC20</option>
              <option value="ripple">RIPPLE</option>
            </select>
          </label>
          <InputField label="Address" value={address} onChange={e => setAddress(e.target.value)} />

          <div style={styles.balanceInfo}>
            Available balance <span style={styles.balanceValue}>{getBalance("usdt", balanceData)}</span>
          </div>
        </div>

        <div style={styles.rightPanel}>
          <CryptoAmountInput 
            label="Value" 
            value={value}
            onChange={setValue}
            containerStyle={{ marginTop: 60 }} 
          />

          <PasswordField
            label="Password"
            value={password}
            onChange={setPassword}
            recoveryUrl="/login"
            recoveryLabel="Forgot Password?"
          />


          <button style={styles.button} onClick={handleWithdraw}>
            Withdraw
          </button>
        </div>
      </div>
    </ModalBase>
  );
}

export default CryptoWithdrawal;

const styles = {
  closeButtonContainer: {
    position: 'absolute',
    top: '0px',
    right: '10px',
    zIndex: 10,
  },
  closeButton: {
    fontSize: '24px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#888',
  },
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderRadius: '10px',
    width: '100%',
    minWidth: '650px',
    overflow: 'hidden',
    fontFamily: 'sans-serif',
  },
  leftPanel: {
    width: '50%',
    padding: '30px',
    borderRight: '1px solid #eee',
    boxSizing: 'border-box',
  },
  rightPanel: {
    width: '48%',
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: '24px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: '35px',
    marginRight: '5px',
  },
  balanceInfo: {
    marginBottom: '10px',
    color: '#555',
    fontSize: '14px',
  },
  balanceValue: {
    float: 'right',
  },
  button: {
    padding: '15px',
    backgroundColor: '#1c787e',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: 'auto',
  },
};
